export const parseCSSValue = (value: string): number => {
  if (!value || value === '0' || value === '0px') return 0;
  // Handle different CSS value formats
  if (value.endsWith('px')) {
    return parseFloat(value);
  }
  if (value.endsWith('em') || value.endsWith('rem')) {
    // Convert to pixels (approximate) - both em and rem use 16px base
    const num = parseFloat(value);
    return num * 16; // 1em/rem ≈ 16px
  }
  if (value.endsWith('%')) {
    // For percentage values, we'll need the parent element context
    return 0; // Skip for now
  }
  return parseFloat(value) || 0;
};
